<template>
  <StepContainer
    v-loading="isLoading"
    :title="$t('APPS.DRAFT.STEPS.BASIC_INFO')"
  >
    <BasicInfoForm v-model="basicInfo" :errors="fieldErrors" />
    <StepControllers slot="actions" @change-step="goToStep" />
  </StepContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_DRAFT_APP_STATE, DRAFT_APP } from '@/store/types';
import StepContainer from '../common/StepContainer';
import BasicInfoForm from './BasicInfoForm';
import StepControllers from '../common/StepControllers';

export default {
  name: 'BasicInfoStep',
  components: { StepContainer, BasicInfoForm, StepControllers },
  inject: ['stepperController'],
  data() {
    return {
      isLoading: false,
      fieldErrors: {},
      basicInfo: {
        author: null,
        appType: null,
        category: null,
        pricingMethod: 'F',
        price: 0,
        haveIap: false,
      },
    };
  },
  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
  },
  watch: {
    draftApp: {
      immediate: true,
      handler(draftApp) {
        this.basicInfo = {
          author: draftApp.developerTitle?.id || null,
          appType: draftApp.appType,
          category: draftApp.category?.id || null,
          pricingMethod: draftApp.pricingMethod,
          price: draftApp.price,
          haveIap: draftApp.haveIap,
        };
      },
    },
  },
  created() {
    this.stepperController.onStepClick(this.goToStep);
  },
  beforeDestroy() {
    this.stepperController.removeOnStepClick(this.goToStep);
  },
  methods: {
    ...mapActions({ checkAndChangeStep: CHANGE_DRAFT_APP_STATE }),

    goToStep(step) {
      this.isLoading = true;
      this.fieldErrors = {};

      this.checkAndChangeStep({ to: step, data: this.basicInfo })
        .catch(({ message, errors = [], fieldErrors = {} }) => {
          this.$message.error(message);
          this.errors = errors;
          this.fieldErrors = fieldErrors;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
